export enum GlobalSearchRoutes {
  BASE = 'search',
  SPECIAL_PRODUCTS = 'special-products'
}
